import { Link } from "react-router-dom";
import { ChevronLeft } from "lucide-react";
import { cn } from "@/lib/cn";

/**
 * Encabezado de pantalla homologado (doc UX 20260627: "dar mayor protagonismo a
 * los títulos principales; revisar la jerarquía entre títulos, subtítulos y
 * textos de ayuda"). Centraliza el patrón back-link + h1 + subtítulo + icono
 * que cada página repetía inline.
 */
export function PageHeader({
  title,
  subtitle,
  icon,
  backTo,
  backLabel = "Volver",
  actions,
  className,
}: {
  title: React.ReactNode;
  subtitle?: React.ReactNode;
  /** Icono decorativo a la izquierda del título. */
  icon?: React.ReactNode;
  /** Si se indica, renderiza el back-link sobre el título. */
  backTo?: string;
  backLabel?: string;
  /** Acciones principales alineadas a la derecha del título. */
  actions?: React.ReactNode;
  className?: string;
}) {
  return (
    <div className={cn("space-y-3", className)}>
      {backTo && (
        <Link
          to={backTo}
          className="inline-flex items-center gap-1 text-sm text-fg-subtle transition hover:text-primary-strong"
        >
          <ChevronLeft className="h-4 w-4" /> {backLabel}
        </Link>
      )}
      <div className="flex flex-wrap items-start justify-between gap-3">
        <div className="flex min-w-0 items-start gap-3">
          {icon && (
            <span className="mt-0.5 grid h-10 w-10 shrink-0 place-items-center rounded-lg bg-primary-tint text-primary-strong">
              {icon}
            </span>
          )}
          <div className="min-w-0">
            <h1 className="text-2xl font-bold tracking-tight text-fg">{title}</h1>
            {subtitle && <p className="mt-1 text-sm text-fg-subtle">{subtitle}</p>}
          </div>
        </div>
        {actions && <div className="flex shrink-0 flex-wrap items-center gap-2">{actions}</div>}
      </div>
    </div>
  );
}
